import "angular";
import "angular-ui-router";
import errorController from "./ErrorController";
import errorRoute from "./ErrorRoute";

const errorModule = angular
    .module("errorModule", ["ui.router"])
    .controller("errorController", errorController)
    .config(errorRoute);

export default errorModule;
